import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    Grid,
    DialogActions,
    DialogContent,
    TextField,
    CircularProgress,
    Button,
    MenuItem,
    Box
} from "@mui/material";
import { useSnackbar } from "notistack";
import http, { buildFormData } from "src/utils/httpHelper";
import GenericInvoiceCatalog from 'src/models/genericInvoiceCatalog';
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import i18n from "src/i18n/i18n";

interface GenericInvoiceCatalogFormProps {
    modalCloseCallback,
    onSuccessCallback
    item?: GenericInvoiceCatalog
}

const GenericInvoiceCatalogForm = ({ modalCloseCallback, onSuccessCallback, item }: GenericInvoiceCatalogFormProps) => {
    const { t }: { t: any } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();
    const catalogModels = {
        'InvoiceCatalogCfdiUses' : '/invoice/catalogs/import/cfdiuses',
        'InvoiceCatalogObjImp' : '/invoice/catalogs/import/obj-imp',
        'InvoiceCatalogCurrencies' : '/invoice/catalogs/import/currencies',
        'InvoiceCatalogPaymentMethods' : '/invoice/catalogs/import/payment-methods',
        'InvoiceCatalogPaymentTypes' : '/invoice/catalogs/import/payment-types',
        'InvoiceCatalogProdServKeys' : '/invoice/catalogs/import/prod-serv-keys',
        'InvoiceCatalogTaxRegimes' : '/invoice/catalogs/import/tax-regimes',
        'InvoiceCatalogTaxTypes' : '/invoice/catalogs/import/tax-types',
        'InvoiceCatalogUnitKeys' : '/invoice/catalogs/import/unit-keys',
    };
    const queryParameters = new URLSearchParams(window.location.search);
    const targetUrl = catalogModels[queryParameters.get("catalog")];

    const formRules = Yup.object().shape({
        excel_file: Yup.mixed()
          .required(i18n.t("VALIDATION.REQUIRED")),
      })
  
      const initialValues = {
        excel_file: "",
      }

    const { handleSubmit, formState: { errors, isSubmitting, isValid }, control, reset } = useForm({
        mode: 'onTouched',
        resolver: yupResolver(formRules),
        defaultValues: initialValues
    });

    return (
        <form noValidate onSubmit={handleSubmit(async (values) => {
            const formData = new FormData();
            buildFormData(formData, {...values});
            let inputFile = (document.getElementById('excel_file') as HTMLInputElement).files[0];
            if (inputFile) {
                formData.set("excel_file", inputFile);
            } else {
                formData.delete("excel_file");
            }
            await http.request({
                method: 'post',
                url: 'api'+targetUrl,
                data: formData
            })
                .then((response) => {
                    onSuccessCallback();
                    enqueueSnackbar(response.data.message, { variant: 'success' });
                })
                .catch((error) => {
                    console.error(error);
                    enqueueSnackbar(error.message, { variant: 'error' });
                });
        })}>
            <DialogContent
                dividers
                sx={{
                    p: 3,
                }}
            >
                <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                        <Controller
                            name="excel_file"
                            control={control}
                            render={({ field }) => (
                            <input
                                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                id="excel_file"
                                type="file"
                            />
                            )}
                        /> 
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions
                sx={{
                    p: 3,
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}
            >
                <Box>
                    <Button color="secondary" onClick={modalCloseCallback}>
                        {t("GENERAL.CANCEL")}
                    </Button>
                    <Button
                        sx={{
                            ml: 2
                        }}
                        type="submit"
                        startIcon={
                            isSubmitting ? <CircularProgress size="1rem" /> : null
                        }
                        disabled={isSubmitting || !isValid}
                        variant="contained"
                    >
                        {t('GENERIC-INVOICE-CATALOGS.UPDATE')}
                    </Button>
                </Box>
            </DialogActions>
        </form>
    )
}

export default GenericInvoiceCatalogForm;